import { useState } from "react";
import EmailSignup from "@/components/EmailSignup";

// Sealed envelope CTA — visually communicates "you're being let into something."
// Click cracks the red wax seal and reveals the waitlist form inline.
// Reusable across drops — pass label, coords, body copy, source, testid.
export default function SealedEnvelope({
  id = "guatemala-signup",
  sealLabel = "VOL. 1 — SEALED UNTIL THE DROP",
  openedLabel = "SEAL BROKEN",
  coords = "14°37′N / 90°31′W",
  stampText = "WC / VOL. 1",
  heading = "BREAK THE SEAL",
  body = "Take your place in line. You'll be the first to know when Vol. 1 opens.",
  openedHeading = "YOU'RE ON THE LIST",
  openedBody = "Drop your email. First access before anyone else. Then we go quiet until we're back.",
  source = "guatemala",
  testidPrefix = "guatemala-signup",
}) {
  const [opened, setOpened] = useState(false);

  return (
    <section
      id={id}
      className="relative bg-black py-32 px-6 md:px-12 border-t border-white/10"
      data-testid={`${testidPrefix}-sealed-envelope`}
    >
      <div className="max-w-3xl mx-auto">
        {!opened && (
          <div className="text-center">
            <div className="wc-label text-[10px] gt-red tracking-[0.4em] mb-6">
              {sealLabel}
            </div>
            <h2 className="wc-heading text-white text-4xl md:text-6xl tracking-widest">
              {heading}
            </h2>
            <p className="text-white/60 mt-6 max-w-xl mx-auto text-base md:text-lg leading-[1.8]">
              {body}
            </p>

            <button
              type="button"
              onClick={() => setOpened(true)}
              className="mt-14 group relative block mx-auto focus:outline-none"
              aria-label="Open the envelope to join the waitlist"
              data-testid={`${testidPrefix}-envelope-open`}
            >
              <div className="relative w-[300px] h-[200px] md:w-[420px] md:h-[280px] mx-auto">
                <div className="absolute inset-0 bg-[#0d0d0d] border border-white/25 shadow-[0_20px_60px_rgba(0,0,0,0.8)] transition-transform duration-500 group-hover:-translate-y-1">
                  <div className="absolute inset-0 opacity-[0.04] bg-[repeating-linear-gradient(45deg,#ffffff_0_1px,transparent_1px_8px)]" />
                  <div
                    aria-hidden
                    className="absolute top-0 left-0 right-0 h-1/2"
                    style={{
                      background:
                        "linear-gradient(to bottom right, transparent 49%, rgba(255,255,255,0.15) 49%, rgba(255,255,255,0.15) 51%, transparent 51%), linear-gradient(to bottom left, transparent 49%, rgba(255,255,255,0.15) 49%, rgba(255,255,255,0.15) 51%, transparent 51%)",
                    }}
                  />
                  <div className="absolute top-3 left-4 right-4 flex justify-between">
                    <span className="wc-label text-[9px] text-white/40 tracking-[0.35em]">
                      {stampText}
                    </span>
                    <span className="wc-label text-[9px] text-white/40 tracking-[0.35em]">
                      {coords}
                    </span>
                  </div>
                </div>

                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-20 md:h-20 transition-transform duration-300 group-hover:scale-105">
                  <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle_at_30%_30%,#E55A3D,#8A2818_70%,#4A1408)] shadow-[0_4px_14px_rgba(196,66,42,0.55),inset_0_-4px_8px_rgba(0,0,0,0.6)]">
                    <div className="absolute inset-0 flex items-center justify-center wc-heading text-black/70 text-xl md:text-2xl">
                      WC
                    </div>
                  </div>
                </div>
              </div>
              <div className="wc-label text-[10px] text-white/50 mt-6 tracking-[0.4em] group-hover:text-white transition-colors">
                TAP TO OPEN
              </div>
            </button>
          </div>
        )}

        {opened && (
          <div className="gt-envelope-open">
            <div className="text-center mb-10">
              <div className="wc-label text-[10px] gt-red tracking-[0.4em] mb-6">
                {openedLabel}
              </div>
              <h2 className="wc-heading text-white text-4xl md:text-6xl tracking-widest">
                {openedHeading}
              </h2>
              <p className="text-white/60 mt-6 max-w-xl mx-auto text-base md:text-lg">
                {openedBody}
              </p>
            </div>
            <EmailSignup
              source={source}
              heading=""
              body=""
              testidPrefix={testidPrefix}
            />
          </div>
        )}
      </div>
    </section>
  );
}
